import { useEffect, useRef } from 'react';

export default function useIgnoreRenderEffect(callback: () => void, dependencies: any[], time = 0) {
    const isInitialMount = useRef<NodeJS.Timeout>();
    useEffect(() => {
        isInitialMount.current = setTimeout(() => {
            callback();
        }, time);
        return () => {
            clearTimeout(isInitialMount.current!);
        };
    }, [...dependencies]);
}
